module.exports = __webpack_public_path__ + "static/media/portalresult.5a07d607.png";